import React from "react";
import Testimonial from "../components/Testimonial";

const TestimonialPage = () => {
  return <Testimonial />;
};

export default TestimonialPage;
